import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import WrapperListLanguage from "../listLanguage/WrapperListLanguage";
import { generatePath } from "../../../utils/getLanguage";

import { StyledFooterContainer, StyledFooterNav, StyledFooterWrapper } from "./styledFooter";
import english from "../../../assets/images/flags/en.png";
import russian from "../../../assets/images/flags/ru.png";
import turkish from "../../../assets/images/flags/tr.png";
import chinese from "../../../assets/images/flags/cn.png";
import { useBetween } from "use-between";
import LanguageStates from "../listLanguage/LanguageStates";

const iconLang = {
  ru: russian,
  en: english,
  tr: turkish,
  'zh-Hant': chinese,
}

const Footer = () => {
  const { t } = useTranslation("footer");
  const [isActiveLang, setIsActiveLang] = useState(false);
  const { activeLang } = useBetween(LanguageStates);

  const setActiveLangBlock = () => setIsActiveLang(!isActiveLang);

  return (
    <StyledFooterWrapper>
      <StyledFooterContainer>
        <div className="footer-info">
          <div className="footer-info__left">
            777xbet.net © {new Date().getFullYear()}
          </div>
          <div className="footer__right">
            <div className="footer-lang__active" onClick={setActiveLangBlock}>
              <img src={activeLang ? iconLang[activeLang] : iconLang.en} alt="lang"/>
            </div>
            <WrapperListLanguage isActiveLang={isActiveLang} setIsActiveLang={setIsActiveLang}/>
          </div>
        </div>
        <StyledFooterNav>
          <ul>
            <li>
              <a
                  href="https://t.me/xbet777_net"
                  target="_blank"
              >{t('support')}</a>
            </li>
            <li>
              <NavLink to={generatePath('/politic')}>
                {t('politic')}
              </NavLink>
            </li>
            <li>
              <NavLink to={generatePath('/wallets')}>
                {t('wallets')}
              </NavLink>
            </li>
            <li>
              <NavLink to={generatePath('/faq')}>
                {t('faq')}
              </NavLink>
            </li>
          </ul>
          <ul>
            <li>
              <a href={'https://t.me/crypto_casino777xbet'} target={'_blank'}>Telegram</a>
            </li>
          </ul>
        </StyledFooterNav>
      </StyledFooterContainer>
    </StyledFooterWrapper>
  );
};

export default Footer;